const routes = {
    auth: '/auth',
    login: '/auth/login'
};

export default routes;
